import React from 'react';
import { Star } from 'lucide-react';

const ReviewsSection = ({ customerReviews, reviewsLoading }) => {
  return (
    <section className="py-10 md:py-14 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-8 md:mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <h2 className="text-xl md:text-3xl font-bold text-gray-900">Müşterilerimiz Ne Diyor?</h2>
            {reviewsLoading && (
              <div className="w-5 h-5 border-2 border-[#006D77]/30 border-t-[#006D77] rounded-full animate-spin"></div>
            )}
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 gap-4 md:gap-6">
          {customerReviews.map((review, index) => (
            <div 
              key={`${review.id}-${index}`} 
              className={`bg-white rounded-2xl p-5 md:p-6 shadow-sm hover:shadow-lg transition-all border border-gray-100 ${reviewsLoading ? 'opacity-70' : 'opacity-100'}`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Üst kısım - Avatar ve Bilgiler */}
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#006D77] to-[#0A9396] rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0">
                  {review.avatar}
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="font-bold text-gray-900">{review.name}</h4>
                    <div className="flex items-center gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        <Star 
                          key={i} 
                          className={`w-4 h-4 ${i < review.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-200'}`} 
                        />
                      ))}
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm">{review.location}</p>
                  {review.service && (
                    <span className="inline-block mt-1 text-xs bg-[#006D77]/10 text-[#006D77] px-2 py-0.5 rounded-full font-medium">
                      {review.service}
                    </span>
                  )}
                </div>
              </div>
              
              {/* Yorum */}
              <p className="text-gray-600 text-sm leading-relaxed">
                "{review.comment}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
